import Routers from "./Router";
import "./index.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/effect-cube";
import "swiper/css/navigation";
import "swiper/css/pagination";

function App() {
	return <Routers />;
}

export default App;
